import { render, staticRenderFns } from "./ImportResourceScreen.vue?vue&type=template&id=7e8870c7&"
import script from "./ImportResourceScreen.vue?vue&type=script&lang=ts&"
export * from "./ImportResourceScreen.vue?vue&type=script&lang=ts&"
import style0 from "./ImportResourceScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports